export { GlobalNotifications } from "./global-notifications.component";
